import { AircraftClass, type AircraftClassId } from './airlines';
import { dollars } from './buildings';

/*
 * The spotters' deck: a viewing terrace by a runway where plane spotters and families come to
 * watch. Every daytime departure from a runway it overlooks brings a little in at the gate and
 * the café (more for a wide-body, most for a military jet), and keeps people talking well of
 * the airport. It must be on a road (visitors come by car) and near enough the runway to see.
 */

/** Tiles from the deck's middle to the runway's middle at most. */
export const SPOTTER_RANGE = 40;
/** Cents a departure brings, by deck level. */
export const SPOTTER_FEE: readonly number[] = [0, dollars(70), dollars(130)];
/** A wide-body draws twice the crowd, a military jet three times. */
export const SPOTTER_WIDEBODY_PERCENT = 200;
export const SPOTTER_MILITARY_PERCENT = 300;
/** Buzz a departure watched from a deck adds. */
export const SPOTTER_BUZZ = 2;

/** What one deck of `level` takes for a departure of class `cls`. */
export function spotterFee(level: number, cls: AircraftClassId, military: boolean): number {
  const base = SPOTTER_FEE[level] ?? 0;
  const percent = military
    ? SPOTTER_MILITARY_PERCENT
    : cls === AircraftClass.Widebody
      ? SPOTTER_WIDEBODY_PERCENT
      : 100;
  return Math.floor((base * percent) / 100);
}
